import React from 'react';
import ReactDOM from 'react-dom';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import {I18nextProvider} from "react-i18next";
import i18next from './i18';
import './index.css';
import { App } from './App';

import * as serviceWorker from './serviceWorker';
ReactDOM.render(
  <React.StrictMode>
      <I18nextProvider i18n={i18next}>
         <App />
      </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
